import { FunctionComponent } from 'react';
import { App as AntApp, AppProps as AntAppProps } from 'antd';
import { useAppProps } from 'antd/lib/app/context';

export type AppProps = AntAppProps;

export const App: FunctionComponent<AntAppProps> & {
  useApp: () => useAppProps;
} = (props) => {
  return <AntApp className="the5ers-App" {...props} />;
};

App.useApp = AntApp.useApp;
